$(".quiz-intro").addClass("active");
quizElementVisibility(1); // const BMR = calcBMR(40, 30);
// let calories = calcCalories(BMR, "gain", "moderate");
// const macro = calcMacro(40, calories, 30);
// printResult(macro, calories, "maintain");

var getQuizResult = function getQuizResult() {
  var inputGoal = $("#input-goal").val();
  var bodyShape = $("#input-bodyshape").val();
  var resultComb = [{
    a1: 'lose',
    a2: 'snacking',
    r: 2
  }, {
    a1: 'lose',
    a2: 'tendtoeatmuch',
    r: 2
  }, {
    a1: 'lose',
    a2: 'healthy',
    r: 4
  }, {
    a1: 'lose',
    a2: 'fastfood',
    r: 2
  }, {
    a1: 'lose10',
    a2: 'snacking',
    r: 3
  }, {
    a1: 'lose10',
    a2: 'tendtoeatmuch',
    r: 3
  }, {
    a1: 'lose10',
    a2: 'healthy',
    r: 4
  }, {
    a1: 'lose10',
    a2: 'fastfood',
    r: 3
  }, {
    a1: 'maintain',
    a2: 'snacking',
    r: 5
  }, {
    a1: 'maintain',
    a2: 'tendtoeatmuch',
    r: 5
  }, {
    a1: 'maintain',
    a2: 'healthy',
    r: 4
  }, {
    a1: 'maintain',
    a2: 'fastfood',
    r: 5
  }, {
    a1: 'gain',
    a2: 'snacking',
    r: 1
  }, {
    a1: 'gain',
    a2: 'tendtoeatmuch',
    r: 1
  }, {
    a1: 'gain',
    a2: 'healthy',
    r: 1
  }, {
    a1: 'gain',
    a2: 'fastfood',
    r: 1
  }];

  for (var i = 0; i <= resultComb.length; i += 1) {
    if (resultComb[i].a1 === inputGoal && resultComb[i].a2 === bodyShape) {
      return resultComb[i].r;
    }
  }

  return 1;
};

function quizMoveStep(currentStep, move) {
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var stepActive = move === "next" ? parseInt(currentStep) + 1 : parseInt(currentStep) - 1;
  setTimeout(function () {
    $(".quiz-step[data-step=" + currentStep + "]").removeClass("active");
    $(".quiz-step[data-step=" + stepActive + "]").addClass("active");
    quizElementVisibility(stepActive);
    quizPrintStep();
    document.activeElement.blur();
    $(window).scrollTop(0);
    console.log('currentStep', stepActive);

    if (currentStep == '4') {
      $('#seeResult').click();
    }

    if (stepActive == 5 || stepActive == 6) {
      $('.quiz-step-status').hide();
    } else {
      $('.quiz-step-status').show();
    }
  }, delay);
}

function quizElementVisibility(stepActive) {
  var currentStep = $(".quiz-step[data-step=" + stepActive + "].active");
  var hideBack = currentStep.data("hide-back");
  var hideStep = currentStep.data("hide-step");
  var hideIcon = currentStep.data("hide-icon");

  if (stepActive === 1) {
    $(".quiz").addClass("quiz-start");
  }

  hideBack ? $(".quiz-prev").hide() : $(".quiz-prev").show();
  hideStep ? $(".quiz-step-status").hide() : $(".quiz-step-status").show();
  hideIcon ? $(".quiz-sm-icon").hide() : $(".quiz-sm-icon").show();
}

function quizPrintStep() {
  var currentStep = parseInt($(".quiz-step.active").data("step")) - 1;
  $(".quiz-current-step").text(currentStep);
}

$(".quiz-prev").click(function (e) {
  e.preventDefault();
  var currentStep = $(".quiz-step.active").data("step");
  console.log('currentStep', currentStep);
  quizMoveStep(currentStep, "prev");
});
$(".quiz-intro .quiz-btn").click(function (e) {
  e.preventDefault();
  $(".quiz").removeClass("quiz-start");
  quizMoveStep(1, "next");
}); //goal

$(".quiz-goal .radio-group input").on("input, click", function () {
  console.log('oninpit');
  var input = $(this).val();
  $(".quiz-goal .radio-group label").removeClass('highlighted');
  $(this).closest('label').addClass('highlighted');
  $("#input-goal").val(input);
  quizMoveStep(2, "next", 500);
}); //bodyshape

$(".quiz-bodyshape .radio-group input").on("input, click", function () {
  var input = $(this).val();
  $(".quiz-bodyshape .radio-group label").removeClass('highlighted');
  $(this).closest('label').addClass('highlighted');
  $("#input-bodyshape").val(input);
  quizMoveStep(3, "next", 500);
}); //active

$(".quiz-active .radio-group input").on("input, click", function () {
  var input = $(this).val();
  $(".quiz-active .radio-group label").removeClass('highlighted');
  $(this).closest('label').addClass('highlighted');
  $("#input-active").val(input);
  quizMoveStep(4, "next", 500);
});
$("#viewResult").on('click', function () {
  $('.quiz-email').find('.error').remove();
  var input = $('#input-email').val();
  var ev = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var emailValid = ev.test(input);

  if (!emailValid) {
    $('#input-email').after('<label for="input-email" class="error invalid-email">Invalid email address</label>');
    return false;
  }

  var tncChecked = $('#tnc_newsletter').is(':checked');

  if (!tncChecked) {
    $('.checkbx-np-privacy').before('<label for="input-email" class="error tnc-invalid">You have not agreed to the Privacy Policy & ToS</label>');
    return false;
  }

   klaviyo_callquiz(input);
  /*var currentCountryName = getCookie('_shopify_country');
  var blueCoreData = {
    email: input,
    country: currentCountryName,
    brand_name: 'skinnymint',
    reg_source: 'quiz',
    brand: 'skinnymint'
  };
  $.post("".concat(window.apiEndpoint, "/bluecore/registrations"), blueCoreData).done(function () {*/
    quizMoveStep(5, "next", 500);
    var resultIndex = getQuizResult();
    $('.quiz-result-' + resultIndex).show('fast');
    $('.quiz-result-panel').each(function (i, obj) {
      if (!$(obj).hasClass('quiz-result-' + resultIndex)) {
        $(obj).remove();
      }
    });
  //});
});

var klaviyo_callquiz = function(Email){
  const options = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      "store": "us",
      "email": Email,
      "quiz": 1
    })
  };
    
  fetch('https://skinnymint-php.herokuapp.com/', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.log(err));
}
$('#skipResult').on('click', function () {
  $('.input-text').find('.error').remove();
  quizMoveStep(5, "next", 500);
  var resultIndex = getQuizResult();
  $('.quiz-result-' + resultIndex).show('fast');
  $('.quiz-result-panel').each(function (i, obj) {
    if (!$(obj).hasClass('quiz-result-' + resultIndex)) {
      $(obj).remove();
    }
  });
}); //email

$("#input-email").on("input", function () {
  var input = $(this).val();
  var ev = /^([_a-zA-Z0-9-]+)(\.[_a-zA-Z0-9-]+)*@([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,3})$/;

  if (!ev.test(input)) {
    $(".allowpromo").hide();
  } else {
    $(".allowpromo").show();
  }
});

function calcBMR(weight, bf) {
  var lbm = weight - weight * (bf / 100);
  return 370 + 21.6 * lbm;
}

function calcCalories(bmr, goal, active) {
  var activeRate = 0;
  if (active === "light") activeRate = 1.375;
  if (active === "moderate") activeRate = 1.55;
  if (active === "extreme") activeRate = 1.725;
  var cals = bmr * activeRate;
  if (goal === "lose") cals = cals * 0.8;
  if (goal === "lose10") cals = cals * 0.9;
  if (goal === "gain") cals = cals * 1.2;
  return Math.round(cals);
}

function calcMacro(weight, calories, fatRatio) {
  var proteinGram = 1.815 * weight;
  var proteinRatio = proteinGram * 4 / calories * 100;
  var fatGram = calories * fatRatio / 100 / 9;
  var carbsRatio = 100 - (proteinRatio + fatRatio);
  var carbsGram = calories * carbsRatio / 100 / 4;
  return {
    gram: {
      carbs: Math.round(carbsGram),
      protein: Math.round(proteinGram),
      fat: Math.round(fatGram)
    },
    percentage: {
      carbs: carbsRatio.toFixed(1),
      protein: proteinRatio.toFixed(1),
      fat: fatRatio.toFixed(1)
    }
  };
}

function showResult() {
  $(".recommendations,.quiz-deal, .quiz-tnc").fadeIn("slow");
}

function printResult(macro, calories, inputgoal) {
  var _macro$percentage = macro.percentage,
      carbsPerc = _macro$percentage.carbs,
      proteinPerc = _macro$percentage.protein,
      fatPerc = _macro$percentage.fat;
  var _macro$gram = macro.gram,
      carbsGram = _macro$gram.carbs,
      proteinGram = _macro$gram.protein,
      fatGram = _macro$gram.fat;
  $("#quiz-calories").text(calories);
  $("#carboGram span").text(carbsGram);
  $("#carbPercentage span").text(carbsPerc);
  $("#proteinGram span").text(proteinGram);
  $("#proteinPercentage span").text(proteinPerc);
  $("#fatGram span").text(fatGram);
  $("#fatPercentage span").text(fatPerc);
  if (inputgoal === "lose") $(".result2").show();
  if (inputgoal === "lose10") $(".result2").show();
  if (inputgoal === "maintain") $(".result3").show();
  if (inputgoal === "gain") $(".result1").show();
  $(".count").each(function () {
    $(this).prop("Counter", 0).animate({
      Counter: $(this).text()
    }, {
      duration: 2000,
      easing: "swing",
      step: function step(now) {
        if (now % 1 === 0) {
          $(this).text(Math.ceil(now));
        } else {
          $(this).text(now.toFixed(1));
        }
      }
    });
  });
  setTimeout(showResult, 2300);
}

$("#specialoffer").change(function (e) {
  e.preventDefault();

  if ($(this).is(":checked")) {
    $(".quiz-email .quiz-btn").show();
  } else {
    $(".quiz-email .quiz-btn").hide();
  }
});
$(document).ready(function () {
  console.log("quiz script loaded");
  var urlForm = "https://skinnymint.us7.list-manage.com/subscribe/post?u=2c7d533501239f3a3a2e25476&amp;id=ba755d4478";
  $("#seeResult").click(function () {
    /*
      const [
        inputage,
        inputheight,
        inputweight,
        inputbodyfat,
        inputgoal,
        inputbodyshape,
        inputactive,
        inputemail
      ] = [
        $("#input-age").val(),
        $("#input-height").val(),
        $("#input-weight").val(),
        $("#input-bodyfat").val(),
        $("#input-goal").val(),
        $("#input-bodyshape").val(),
        $("#input-active").val(),
        $("#input-email")
          .val()
          .toLowerCase()
      ];
       const quizinput =
        inputage +
        "yo, " +
        inputheight +
        "cm, " +
        inputweight +
        "kg, " +
        inputbodyfat +
        "%, " +
        inputbodyshape +
        ", " +
        inputactive;
       const BMR = calcBMR(inputweight, inputbodyfat);
      let calories = calcCalories(BMR, inputgoal, inputactive);
      const macro = calcMacro(inputweight, calories, 30);
       printResult(macro, calories, inputgoal);
       const {
        carbs: carbsPerc,
        protein: proteinPerc,
        fat: fatPerc
      } = macro.percentage;
      const { carbs: carbsGram, protein: proteinGram, fat: fatGram } = macro.gram;
       let store = 'SG';
      if (Shopify.shop == 'skinny-mint-us.myshopify.com') {
        store = 'US';
      } else if (Shopify.shop == 'skinny-mint-au.myshopify.com') {
        store = 'AU';
      } else if (Shopify.shop == 'skinny-mint-rw.myhsopify.com') {
        store = 'INT';
      }
       $.ajax({
        url: urlForm,
        cache: false,
        data: {
          EMAIL: inputemail,
          QUIZINPUT: quizinput,
          CALORIES: calories,
          CARBS: carbsGram,
          PROTEIN: proteinGram,
          FAT: fatGram,
          CARBSP: carbsPerc,
          PROTEINP: proteinPerc,
          FATP: fatPerc,
          STORE: store,
          GOAL: inputgoal
        },
        dataType: "jsonp",
        contentType: "application/json; charset=utf-8",
        beforeSend: function() {
          $(".waitlist-form button").text("Submit...");
        },
        complete: function(resp) {}
      });
    
      quizMoveStep(9, "next", 0);
    */
    var inputGoal = $("#input-goal").val();
    var bodyShape = $("#input-bodyshape").val();
    var inputActive = $("#input-active").val();
    var resultIndex = getQuizResult(inputGoal, bodyShape);
    console.log('resultIndex', resultIndex); //setTimeout(showResult, 2300);
  });
});
$('.product-card').on('click', function () {
  $('.product-card').removeClass('border-pink').removeClass('panel-active');
  $('.product-card').find('.accordion').removeClass('active');
  $('.product-card').find('.panel').removeAttr('style');
  $(this).addClass('border-pink').addClass('panel-active');
  $(this).find('.accordion').addClass('active');
  $(this).find('.panel').css({
    'max-height': '100vh'
  });
});